import React from "react";
import "./Sidebarr.css";
import { createBrowserHistory } from "history";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import { Card, Button } from "react-bootstrap";
import AdminNav from "../Pages/AdminNav";

import {
  faUser,
  faList,
  faShieldAlt,
  faBell,
  faColumns,
  faTrophy,
  faCog,
  faEdit,
  faSignOutAlt,
} from "@fortawesome/free-solid-svg-icons";
import {
  faInstagram,
  faTwitter,
  faFacebook,
  faWhatsapp,
} from "@fortawesome/free-brands-svg-icons";
import { FaTrophy, FaChartBar, FaBullseye } from "react-icons/fa";

const history = createBrowserHistory();

const Profile = () => {
  const handleNavigation = (path) => {
    history.push(path);
  };

  return (
    <div>
      <AdminNav />
      
      <div className="wrapper">
        <aside id="sidebar" className="collapsed expand">
          <div className="d-flex">
            <button
              className="toggle-btn ms-auto"
              type="button"
              onClick={() =>
                document.querySelector("#sidebar").classList.toggle("expand")
              }
              style={{
                backgroundColor: "rgb(217, 6, 6)",
                border: "2px solid rgb(217, 6, 6)",
                borderRadius: "5px",
              }}
            >
              <span className="close-btn-symbol">
                <FontAwesomeIcon icon={faList} />
              </span>
            </button>

            <div className="sidebar-logo">
              <a href="#"></a>
            </div>
          </div>
          <ul className="sidebar-nav">
            <li className="sidebar-item">
              <a href="#" className="sidebar-link">
                <FontAwesomeIcon
                  icon={faUser}
                  onClick={() => handleNavigation("/dashboard")}
                />
                <span
                  className="icon-text"
                  onClick={() => handleNavigation("/dashboard")}
                >
                  Dashboard
                </span>
              </a>
            </li>
            <li className="sidebar-item">
              <a href="#" className="sidebar-link">
                <FontAwesomeIcon
                  icon={faList}
                  onClick={() => handleNavigation("/profile")}
                />
                <span
                  className="icon-text"
                  onClick={() => handleNavigation("/profile")}
                >
                  Student Dashboard
                </span>
              </a>
            </li>
            <li className="sidebar-item">
              <a
                href="#"
                className="sidebar-link collapsed has-dropdown"
                data-bs-toggle="collapse"
                data-bs-target="#auth"
                aria-expanded="false"
                aria-controls="auth"
              >
                <FontAwesomeIcon
                  icon={faShieldAlt}
                  onClick={() => {
                    handleNavigation("/courses");
                    document.getElementById("auth").classList.toggle("show"); // Toggle the 'show' class to close the accordion
                  }}
                />
                <span> Courses </span>
              </a>
              <ul
                id="auth"
                className="sidebar-dropdown list-unstyled collapse"
                data-bs-parent="#sidebar"
              >
                <li className="sidebar-item">
                  <a
                    href="#"
                    className="sidebar-link"
                    onClick={() => handleNavigation("/addcourses")}
                  >
                    Add Course
                  </a>
                </li>
                <li className="sidebar-item">
                  <a
                    href="#"
                    className="sidebar-link"
                  >
                    Difficulties
                  </a>
                </li>
                <li className="sidebar-item">
                  <a
                    href="#"
                    className="sidebar-link"
                  >
                    Tags
                  </a>
                </li>
                <li className="sidebar-item">
                  <a
                    href="#"
                    className="sidebar-link"
                  >
                    Tracks
                  </a>
                </li>
                <li className="sidebar-item">
                  <a
                    href="#"
                    className="sidebar-link"
                  >
                    Lessons
                  </a>
                </li>
                <li className="sidebar-item">
                  <a
                    href="#"
                    className="sidebar-link"
                  >
                    Reviews
                  </a>
                </li>
              </ul>
            </li>

           
            <li className="sidebar-item">
              <a href="#" className="sidebar-link ">
                <FontAwesomeIcon
                  icon={faColumns}
                  onClick={() => handleNavigation("/certificates")}
                />
                <span
                  className="icon-text"
                  onClick={() => handleNavigation("/certificates")}
                >
                  My Certificates
                </span>
              </a>
            </li>
            <li className="sidebar-item">
              <a href="#" className="sidebar-link">
                <FontAwesomeIcon
                  icon={faTrophy}
                  onClick={() => handleNavigation("/achievements")}
                />
                <span
                  className="icon-text"
                  onClick={() => handleNavigation("/achievements")}
                >
                  My Achievements
                </span>
              </a>
            </li>
            <li className="sidebar-item">
              <a href="#" className="sidebar-link">
                <FontAwesomeIcon
                  icon={faBell}
                  onClick={() => handleNavigation("/Notification")}
                />
                <span
                  className="icon-text"
                  onClick={() => handleNavigation("/Notification")}
                >
                  Notification
                </span>
              </a>
            </li>
            <li className="sidebar-item">
              <a href="#" className="sidebar-link">
                <FontAwesomeIcon
                  icon={faCog}
                  onClick={() => handleNavigation("/Setting")}
                />
                <span
                  className="icon-text"
                  onClick={() => handleNavigation("/Setting")}
                >
                  Settings
                </span>
              </a>
            </li>

            <li className="sidebar-footer">
              <a href="#" className="sidebar-link">
                <FontAwesomeIcon icon={faSignOutAlt} />
                <span className="icon-text">Logout</span>
              </a>
            </li>
          </ul>
        </aside>
        <div className="main p-3" style={{ height: "100vh" }}>
          <div className="text-start">
            <h1 className="">Admin Dashboard</h1>
          </div>
         
          <div className="wrapper">
            {/* ... (your existing sidebar code) */}
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Profile;
